import React, { useEffect, useMemo, useState } from "react";
import { TailSpin, ThreeDots } from "react-loader-spinner";
import {
  API_EVALUATE_PERFORMANCE,
  API_EXPORT_PERFORMANCE_EVALUATION,
  API_GET_EVALUATED_PERFORMANCE,
  API_GET_PERFORMANCE,
  API_GET_PERFORMANCE_EMPLOYEE_LIST,
  API_PERFORMANCE_Evaluation,
  API_PERFORMANCE_POINTS,
  GET_EMPLOYEE_LIST,
} from "../../config/Endpoints";
import Cookies from "js-cookie";
import { getApi, postApi } from "../../utils/api";
import { toggleMenu } from "../../utils/helpers";
import Select, { components } from "react-select";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";
import PageTitle from "../../components/PageTitle";
import ReadOnlyPerformance from "../../components/Performance/ReadOnlyPerformance";
import PerformanceNavigation from "../../components/Performance/PerformanceNavigation";
import { performance } from "../../data";
import EvaluatePerformance from "../../components/Performance/EvaluatePerformance";
import axios from "axios";
import ReadOnlyMarksPerformance from "../../components/Performance/ReadOnlyMarksPerformance";

const EvaluateEmployeeV2 = ({ title, description }) => {
  const [employeeList, setEmployeeList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const selectedEmployeeDefaultValue = { value: "", label: "All", type: "" };
  const [selectedEmployee, setSelectedEmployee] = useState(
    selectedEmployeeDefaultValue
  );
  const evaluationFormDataInitialState = {
    certifications: {
      associate: 0,
      administrator: 0,
      architect: 0,
      consultant: 0,
      developer: 0,
    },
    otherCertifications: 0,
    exercisesCompleted: 0,
    mockInterviewsGiven: 0,
    mockInterviewDetails: 0,
    expertLedSessionsPresented: 0,
    coffeeNLearnSessions: 0,
    isMuleSoftMeetupSpeaker: 0,
    meetupDetails: 0,
    eventDetails: 0,
    isMuleSoftMeetupLeader: 0,
    isMuleSoftMentor: 0,
    isMuleSoftAmbassador: 0,
    salesforceSessionsPresented: 0,
    completedCaeliusAIEnablementProgram: 0,
    trainingBuddyAssisted: 0,
    mentorLeadAssisted: 0,
    reviewsTaken: 0,
    projectsUndertaken: 0,
    projects: 0,
    codeReviewsTaken: 0,
    codeReviewsTakenArchitect: 0,
    architecturalSolutionsDesigned: 0,
    achievements: 0,
    csatScore5Projects: 0,
    selfAssessment: {
      jobSkills: 0,
      technicalSkills: 0,
      responsiveness: 0,
      communicationSkills: 0,
      teamwork: 0,
      flexibility: 0,
      inclusiveness: 0,
      initiative: 0,
    },
    initiativeDetails: 0,
    trainingDevelopmentNeeds: 0,
    additionalInfo: 0,
  };
  const [performanceData, setPerformanceData] = useState();
  const [evaluationFormData, setEvaluationFormData] = useState(
    evaluationFormDataInitialState
  );
  const [evaluateMode, setEvaluateMode] = useState(false);
  const accessToken = Cookies.get("accessToken");

  const fetchEmployeeList = async () => {
    setIsLoading(true);
    try {
      const res = await getApi(API_GET_PERFORMANCE_EMPLOYEE_LIST, accessToken);
      setEmployeeList(res.data.data);
    } catch (error) {
      console.error(error);

      toast.error(error?.response?.data?.message || "Something went wrong.");
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchEmployeeList();
  }, []);

  useEffect(() => {
    const employeeId = selectedEmployee.value;

    setEvaluateMode(false);
    handleReset();
    if (employeeId) {
      fetchEmployeePerformance(employeeId);
    }
  }, [selectedEmployee]);

  const handleExport = async () => {
    setIsLoading(true);
    try {
      const employeeId = selectedEmployee.value;
      let url;
      if (employeeId) {
        url = API_EXPORT_PERFORMANCE_EVALUATION + `?userId=${employeeId}`;
      } else {
        url = API_EXPORT_PERFORMANCE_EVALUATION;
      }
      await fetch(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/vnd.ms-excel",
        },
      })
        .then((res) => {
          if (res.status !== 200) {
            toast.error("Something went wrong please try again later", {
              position: toast.POSITION.TOP_RIGHT,
            });
            return;
          }

          return res.blob();
        })
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `performance_evaluation.xlsx`;
          link.click();
          URL.revokeObjectURL(url);
        })
        .catch((err) => {
          toast.error("Something went wrong please try again later", {
            position: toast.POSITION.TOP_RIGHT,
          });
        });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchEmployeePerformance = async (employeeId) => {
    setIsLoading(true);
    try {
      let url;
      if (selectedEmployee?.type === "Evaluated") {
        url = API_GET_EVALUATED_PERFORMANCE + `?userId=${employeeId}`;
      } else {
        url = API_GET_PERFORMANCE + `?userId=${employeeId}`;
      }

      const res = await getApi(url, accessToken);

      if (selectedEmployee?.type === "Evaluated") {
        setPerformanceData(res.data.data.evaluatorDataRequest);
      } else {
        setPerformanceData(res.data.data.performanceData);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const sections = performance.sections;

  const sectionRefs = {};
  sections.forEach((section) => {
    sectionRefs[section] = React.createRef();
  });

  const optionList = employeeList?.map((item) => ({
    value: item.employeeId,
    label: item.name.trim(),
    type: item.status === 0 ? "Pending" : "Evaluated",
  }));

  optionList.unshift(selectedEmployeeDefaultValue);

  const Option = (props) => {
    const { data } = props;
    const { label, type } = data;

    return (
      <components.Option {...props}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>{label}</span>
          <span style={{ fontSize: "12px", color: "gray" }}>({type})</span>
        </div>
      </components.Option>
    );
  };

  const handleReset = () => {
    setPerformanceData();
    setEvaluationFormData(evaluationFormDataInitialState);
  };

  const computeMarks = () => {
    const marks = {
      totalMarks: 0,
      section1: 0,
      section2: 0,
      section3: 0,
      section4: 0,
      section5: 0,
    };

    marks.section1 =
      parseInt(evaluationFormData.certifications.associate) +
      parseInt(evaluationFormData.certifications.architect) +
      parseInt(evaluationFormData.certifications.administrator) +
      parseInt(evaluationFormData.certifications.consultant) +
      parseInt(evaluationFormData.certifications.developer) +
      parseInt(evaluationFormData.otherCertifications) +
      parseInt(evaluationFormData.exercisesCompleted) +
      parseInt(evaluationFormData.mockInterviewsGiven) +
      parseInt(evaluationFormData.mockInterviewDetails) +
      parseInt(evaluationFormData.expertLedSessionsPresented) +
      parseInt(evaluationFormData.coffeeNLearnSessions) +
      parseInt(evaluationFormData.isMuleSoftMeetupSpeaker) +
      parseInt(evaluationFormData.meetupDetails) +
      parseInt(evaluationFormData.isMuleSoftMeetupLeader) +
      parseInt(evaluationFormData.isMuleSoftMentor) +
      parseInt(evaluationFormData.isMuleSoftAmbassador) +
      parseInt(evaluationFormData.salesforceSessionsPresented) +
      parseInt(evaluationFormData.completedCaeliusAIEnablementProgram);

    marks.section2 =
      parseInt(evaluationFormData.trainingBuddyAssisted) +
      parseInt(evaluationFormData.mentorLeadAssisted) +
      parseInt(evaluationFormData.reviewsTaken);

    marks.section3 =
      parseInt(evaluationFormData.projectsUndertaken) +
      parseInt(evaluationFormData.projects) +
      parseInt(evaluationFormData.codeReviewsTaken) +
      parseInt(evaluationFormData.codeReviewsTakenArchitect) +
      parseInt(evaluationFormData.architecturalSolutionsDesigned) +
      parseInt(evaluationFormData.achievements) +
      parseInt(evaluationFormData.csatScore5Projects);

    marks.section4 =
      parseInt(evaluationFormData.selfAssessment.jobSkills) +
      parseInt(evaluationFormData.selfAssessment.technicalSkills) +
      parseInt(evaluationFormData.selfAssessment.responsiveness) +
      parseInt(evaluationFormData.selfAssessment.communicationSkills) +
      parseInt(evaluationFormData.selfAssessment.teamwork) +
      parseInt(evaluationFormData.selfAssessment.flexibility) +
      parseInt(evaluationFormData.selfAssessment.inclusiveness) +
      parseInt(evaluationFormData.selfAssessment.initiative) +
      parseInt(evaluationFormData.initiativeDetails);

    marks.section5 =
      parseInt(evaluationFormData.trainingDevelopmentNeeds) +
      parseInt(evaluationFormData.additionalInfo);

    marks.totalMarks =
      marks.section1 +
      marks.section2 +
      marks.section3 +
      marks.section4 +
      marks.section5;

    return marks;
  };

  const prepareRequestPayload = () => {
    const marks = computeMarks();

    const payload = {
      userId: selectedEmployee.value,
      totalMarks: marks.totalMarks,
      sectionMarks: {
        section1: marks.section1,
        section2: marks.section2,
        section3: marks.section3,
        section4: marks.section4,
        section5: marks.section5,
      },
      evaluatorDataRequest: {
        certifications: {
          associate: {
            answer: performanceData.certifications.associate.answer,
            marks: evaluationFormData.certifications.associate,
          },
          administrator: {
            answer: performanceData.certifications.administrator.answer,
            marks: evaluationFormData.certifications.administrator,
          },
          architect: {
            answer: performanceData.certifications.architect.answer,
            marks: evaluationFormData.certifications.architect,
          },
          consultant: {
            answer: performanceData.certifications.consultant.answer,
            marks: evaluationFormData.certifications.consultant,
          },
          developer: {
            answer: performanceData.certifications.developer.answer,
            marks: evaluationFormData.certifications.developer,
          },
        },
        otherCertifications: {
          answer: performanceData.otherCertifications.answer,
          marks: evaluationFormData.otherCertifications,
        },
        exercisesCompleted: {
          answer: performanceData.exercisesCompleted.answer,
          marks: evaluationFormData.exercisesCompleted,
        },
        mockInterviewsGiven: {
          answer: performanceData.mockInterviewsGiven.answer,
          marks: evaluationFormData.mockInterviewsGiven,
        },
        mockInterviewDetails: {
          answer: performanceData.mockInterviewDetails.answer,
          marks: evaluationFormData.mockInterviewDetails,
        },
        expertLedSessionsPresented: {
          answer: performanceData.expertLedSessionsPresented.answer,
          marks: evaluationFormData.expertLedSessionsPresented,
        },
        coffeeNLearnSessions: {
          answer: performanceData.coffeeNLearnSessions.answer,
          marks: evaluationFormData.coffeeNLearnSessions,
        },
        isMuleSoftMeetupSpeaker: {
          answer: performanceData.isMuleSoftMeetupSpeaker.answer,
          marks: evaluationFormData.isMuleSoftMeetupSpeaker,
        },
        meetupDetails: {
          answer: performanceData.meetupDetails.answer,
          marks: evaluationFormData.meetupDetails,
        },
        eventDetails: {
          answer: performanceData.eventDetails.answer,
          marks: evaluationFormData.eventDetails,
        },
        isMuleSoftMeetupLeader: {
          answer: performanceData.isMuleSoftMeetupLeader.answer,
          marks: evaluationFormData.isMuleSoftMeetupLeader,
        },
        isMuleSoftMentor: {
          answer: performanceData.isMuleSoftMentor.answer,
          marks: evaluationFormData.isMuleSoftMentor,
        },
        isMuleSoftAmbassador: {
          answer: performanceData.isMuleSoftAmbassador.answer,
          marks: evaluationFormData.isMuleSoftAmbassador,
        },
        salesforceSessionsPresented: {
          answer: performanceData.salesforceSessionsPresented.answer,
          marks: evaluationFormData.salesforceSessionsPresented,
        },
        completedCaeliusAIEnablementProgram: {
          answer: performanceData.completedCaeliusAIEnablementProgram.answer,
          marks: evaluationFormData.completedCaeliusAIEnablementProgram,
        },
        trainingBuddyAssisted: {
          answer: performanceData.trainingBuddyAssisted.answer,
          marks: evaluationFormData.trainingBuddyAssisted,
        },
        mentorLeadAssisted: {
          answer: performanceData.mentorLeadAssisted.answer,
          marks: evaluationFormData.mentorLeadAssisted,
        },
        reviewsTaken: {
          answer: performanceData.reviewsTaken.answer,
          marks: evaluationFormData.reviewsTaken,
        },
        projectsUndertaken: {
          answer: performanceData.projectsUndertaken.answer,
          marks: evaluationFormData.projectsUndertaken,
        },
        projects: {
          answer: performanceData.projects.answer,
          marks: evaluationFormData.projects,
        },
        codeReviewsTaken: {
          answer: performanceData.codeReviewsTaken.answer,
          marks: evaluationFormData.codeReviewsTaken,
        },
        codeReviewsTakenArchitect: {
          answer: performanceData.codeReviewsTakenArchitect.answer,
          marks: evaluationFormData.codeReviewsTakenArchitect,
        },
        architecturalSolutionsDesigned: {
          answer: performanceData.architecturalSolutionsDesigned.answer,
          marks: evaluationFormData.architecturalSolutionsDesigned,
        },
        achievements: {
          answer: performanceData.achievements.answer,
          marks: evaluationFormData.achievements,
        },
        csatScore5Projects: {
          answer: performanceData.csatScore5Projects.answer,
          marks: evaluationFormData.csatScore5Projects,
        },
        selfAssessment: {
          jobSkills: {
            answer: performanceData.selfAssessment.jobSkills.answer,
            marks: evaluationFormData.selfAssessment.jobSkills,
          },
          technicalSkills: {
            answer: performanceData.selfAssessment.technicalSkills.answer,
            marks: evaluationFormData.selfAssessment.technicalSkills,
          },
          responsiveness: {
            answer: performanceData.selfAssessment.responsiveness.answer,
            marks: evaluationFormData.selfAssessment.responsiveness,
          },
          communicationSkills: {
            answer: performanceData.selfAssessment.communicationSkills.answer,
            marks: evaluationFormData.selfAssessment.communicationSkills,
          },
          teamwork: {
            answer: performanceData.selfAssessment.teamwork.answer,
            marks: evaluationFormData.selfAssessment.teamwork,
          },
          flexibility: {
            answer: performanceData.selfAssessment.flexibility.answer,
            marks: evaluationFormData.selfAssessment.flexibility,
          },
          inclusiveness: {
            answer: performanceData.selfAssessment.inclusiveness.answer,
            marks: evaluationFormData.selfAssessment.inclusiveness,
          },
          initiative: {
            answer: performanceData.selfAssessment.initiative.answer,
            marks: evaluationFormData.selfAssessment.initiative,
          },
        },
        initiativeDetails: {
          answer: performanceData.initiativeDetails.answer,
          marks: evaluationFormData.initiativeDetails,
        },
        trainingDevelopmentNeeds: {
          answer: performanceData.trainingDevelopmentNeeds.answer,
          marks: evaluationFormData.trainingDevelopmentNeeds,
        },
        additionalInfo: {
          answer: performanceData.additionalInfo.answer,
          marks: evaluationFormData.additionalInfo,
        },
      },
    };

    return payload;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const payload = prepareRequestPayload();
      await axios
        .post(API_EVALUATE_PERFORMANCE, payload, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((res) => {
          toast.success(res.data, {
            position: toast.POSITION.TOP_RIGHT,
          });
          fetchEmployeeList();
          setEvaluationFormData(evaluationFormDataInitialState);
          setEvaluateMode(false);
          setSelectedEmployee(selectedEmployeeDefaultValue);
        })
        .catch((err) => {
          toast.success(err.response.data, {
            position: toast.POSITION.TOP_RIGHT,
          });
        });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="wrapper-body">
      {isLoading && (
        <div className="overlay">
          <div className="mt-5">
            <TailSpin
              height="100"
              width="100"
              radius="1"
              color="blue"
              ariaLabel="tail-spin-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={true}
            />
          </div>
        </div>
      )}
      {/* Page Heading */}
      <div className="page-heading">
        <div id="showMenuBtn" className="collapse-button" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <PageTitle title={title} description={description} />
        <div className="filters m-0">
          <div className="actions d-flex gap-2">
            {employeeList.length > 0 && (
              <button className="export theme-button" onClick={handleExport}>
                {selectedEmployee?.value === "" ? "Export All" : "Export"}
              </button>
            )}
          </div>
        </div>
      </div>
      <div className="card mb-3">
        <form id="assign-asset">
          <h3 className="heading">Employee</h3>
          <div className="inputs">
            <div className="row">
              <div className="col-md-3"></div>
              <div className="col-md-6">
                <div className="dropdown-container">
                  <Select
                    options={optionList}
                    components={{ Option }}
                    onChange={setSelectedEmployee}
                    value={selectedEmployee}
                    placeholder="Select employee"
                    isSearchable={true}
                    isDisabled={employeeList?.length === 0}
                    isRequired={true}
                  />
                </div>
              </div>
              <div className="col-md-2"></div>
            </div>
          </div>
        </form>
      </div>

      {!isLoading && (
        <>
          <div className="d-flex my-3 justify-content-end">
            <div className="actions">
              {selectedEmployee?.type === "Pending" && (
                <ActionButtons
                  evaluateMode={evaluateMode}
                  setEvaluateMode={setEvaluateMode}
                  handleSubmit={handleSubmit}
                />
              )}
            </div>
          </div>

          {performanceData && (
            <div className="row">
              <PerformanceNavigation sectionRefs={sectionRefs} />
              {evaluateMode ? (
                <EvaluatePerformance
                  data={performanceData}
                  formData={evaluationFormData}
                  setFormData={setEvaluationFormData}
                  sectionRefs={sectionRefs}
                />
              ) : selectedEmployee?.type === "Evaluated" ? (
                <ReadOnlyMarksPerformance
                  data={performanceData}
                  sectionRefs={sectionRefs}
                />
              ) : (
                <ReadOnlyPerformance
                  data={performanceData}
                  sectionRefs={sectionRefs}
                />
              )}
            </div>
          )}
          <div className="row">
            <div className="col-md-3"></div>
            <div className="col-md-9">
              {selectedEmployee?.type === "Pending" && (
                <ActionButtons
                  evaluateMode={evaluateMode}
                  setEvaluateMode={setEvaluateMode}
                  handleSubmit={handleSubmit}
                />
              )}
            </div>
          </div>
        </>
      )}

      {/* Footer */}
      <Footer />
    </div>
  );
};

const ActionButtons = ({ evaluateMode, setEvaluateMode, handleSubmit }) => {
  return (
    <div className="d-flex gap-2">
      {evaluateMode ? (
        <button
          className="export theme-button bg-danger"
          onClick={() => setEvaluateMode(false)}
        >
          Cancel
        </button>
      ) : (
        <button
          className="export theme-button"
          onClick={() => setEvaluateMode(true)}
        >
          Evaluate
        </button>
      )}
      {evaluateMode && (
        <button
          className="export theme-button"
          onClick={(e) => {
            setEvaluateMode(true);
            handleSubmit(e);
          }}
        >
          Submit
        </button>
      )}
    </div>
  );
};

export default EvaluateEmployeeV2;
